<template>
  <div
    class="dropbox"
    v-bind:class="{ 'dragHover': isDragging, 'isSaving': isSaving }"
    draggable
    @drop="drop"
    @dragenter="isDragging = true"
    @dragleave="isDragging = false"
  >
    <input
      type="file"
      :multiple="multiple"
      :name="type"
      :disabled="isSaving"
      @change="filesChange"
      :accept="accept"
      class="input-file"
    >
    <template>
      <div>
        <p class="p-2" v-if="!isSaving && !isDragging">
          <span class="d-block" v-text="_trans('Drag your image here')"></span>
          <span class="d-block" v-text="_trans('Or click to browse')"></span>
        </p>
        <p class="p-2" v-else-if="!isSaving && isDragging" v-text="_trans('Relese here your image')"></p>
        <p class="p-2" v-else v-text="_trans('Uploading image...')"></p>
      </div>
    </template>
    <div v-if="isSaving" class="loaderBar">
      <div class="loader" v-bind:style="loadingProgress"></div>
    </div>
  </div>
</template>

<script>
    import {bus} from "@store/dau";
    import { HandlerAPI } from '@3cad/nextcore';

    export default {
        data() {
            return {
                accept: "image/*",
                isSaving: false,
                isDragging: false,
                fileList: [],
                progress: 0
            }
        },
        props:{
            name:{ type:String, default:'' },
            newname: { type:String, default:'' },
            type: { type:String, default:'GEN' },
            catalog: { type:String, default:''},
            dim: String,
            images: { type:Boolean, default: false },
            multiple: { type:Boolean, default: false },
            image: String,
            bgUrl: { type: String, default: null }
        },
        computed: {
            prj() {
                return this.$store.state.project;
            },
            loadingProgress() {
                return {
                    width: (this.progress * 100) + '%'
                }
            },
            bgStyle() {
                return {
                    backgroundImage: this.bgUrl ? ('url(' + this.bgUrl + ')') : ''
                }
            }
        },
        methods: {
            drop(e) {
                this.isDragging = false;
                if (e.dataTransfer) {
                    if (e.dataTransfer.files && e.dataTransfer.files.length)  {
                        // this.fileList = e.dataTransfer.files;
                        this.isSaving = true;
                        this.progress = 0;
                        let fileName = e.dataTransfer.files[0].name;
                        HandlerAPI.uploadFiles(e.dataTransfer.files, this.prj.id, evt => {
                                this.progress = evt.loaded / evt.total;
                                // bus.$emit('startLoading', null, evt.loaded / evt.total)
                            },
                            res => {
                                this.isSaving = false;
                                // this.resetFileList(e);
                                if(res.filename)
                                    this.$emit('loaded', res.filename);
                                else
                                    this.$emit('error', res);
                            },
                            err => {
                                this.isSaving = false;

                                if(err.internal_error === 'E05')
                                    this.$emit('loaded', fileName);
                                else
                                    this.$emit('error', err);
                                // this.resetFileList(e);
                            })
                    }
                }
                /*if (e.dataTransfer) {
                    if (e.dataTransfer.files && e.dataTransfer.files.length)  {
                        this.filesChange(e.dataTransfer.files);
                    } else {
                        let aa=e.dataTransfer.getData("text/html");
                        if (aa && aa.substring(0,4) === "<img")     {
                            let div = document.createElement("div")
                            div.innerHTML = aa;
                            let s = div.firstChild.getAttribute("src");
                            if (s !== null)  {
                                this.filesChange([],s);
                            }
                        }
                    }
                    this.$emit('drop',res)
                }*/
            },
            filesChange(e) {
                this.isSaving=true;
                this.progress = 0;
                let fileName = e.target.files[0].name;
                HandlerAPI.uploadFiles(e.target.files, this.prj.id, evt => {
                        this.progress = evt.loaded / evt.total;
                        // bus.$emit('startLoading', null, evt.loaded / evt.total)
                    },
                    res => {
                        this.isSaving = false;
                        // this.resetFileList(e);
                        if(res.filename)
                            this.$emit('loaded', res.filename);
                        else
                            this.$emit('error', res);
                    },
                    err => {
                        this.isSaving = false;

                        if(err.internal_error === 'E05')
                            this.$emit('loaded', fileName);
                        else
                            this.$emit('error', err);
                        // this.resetFileList(e);
                    })

                /*let imageUploaded = new File([fileList[0]], 'tmp.jpg', { type: 'image/jpeg' });
                let imageSrc = (window.URL ? URL : webkitURL).createObjectURL(imageUploaded);
                this.imageSrc = imageSrc;
                this.$emit('loaded', imageSrc);*/

                /*Dau.uploadFiles(fileList, this.prj.id,
                    res => {
                        this.saving = false;
                        Dau.downloadReq(res.filename, this.prj.id,
                            res => {
                                let imageUploaded = new File([res], 'tmp.jpg', { type: 'image/jpeg' });
                                let imageSrc = (window.URL ? URL : webkitURL).createObjectURL(imageUploaded);
                                this.imageSrc = imageSrc;
                                this.$emit('loaded', imageSrc);
                            },
                            err => {
                                console.error(err);
                            });
                    },
                    err => {
                        console.error(err);
                        this.saving=false;
                        this.$emit('error',err);
                    });*/
            }
        }
    }
</script>
<style scoped lang="scss">
  .dropbox {
    outline: 2px dashed $gray-light;
    height: 100px;
    color: $info;
    padding: 10px 10px;
    position: relative;
    cursor: pointer;
    background-color: lighten($white, 10);
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: 10px;
    background-position: 50% 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    font-size: 1.4rem;

    &.dragHover {
      background-color: lighten($green, 40);
      color: $white;
    }

    &.isSaving {
      outline-color: transparent;
    }

    .loaderBar {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 4px;
      background-color: $gray-light;

      .loader {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        background-color: $primary;
      }
    }

    .input-file {
      opacity: 0;
      width: 100%;
      height: 100%;
      position: absolute;
      cursor: pointer;
    }

    p {
      text-align: center;
      /*background-color: rgba(255,255,255,0.7);*/
    }

    &:hover {
      color: $primary;
      outline: 2px dashed $primary;
    }
  }

  p {
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/_eng/globals/_uploadImg.vue